import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo, CampoNumero } from './';
import * as Dati from '../Dati';
import * as Glob from '../Globale';

interface IMandantiProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON mandanti
    ColonnaCapogruppo?: boolean;
}

interface IMandantiState {
    QuotaRimanente: number;
    Dati: Dati.CDatoMandante[];
}

export class Mandanti extends BasePureComponent<IMandantiProps, IMandantiState> {

    public static defaultProps: Partial<IMandantiProps> = {
        ColonnaCapogruppo: true
    };

    constructor(props: IMandantiProps) {
        super(props);

        this.state = {
            QuotaRimanente: 100,
            Dati: []
        };
    }

    static getDerivedStateFromProps(props: IMandantiProps, state: IMandantiState): IMandantiState {
        let DatiApp: Dati.CDatoMandante[] = [];
        let QR: number = 100;
        if (props.Value != undefined && props.Value != "") {
            DatiApp = JSON.parse(props.Value);
            for (let D: number = 0; D < DatiApp.length; D++) {
                QR -= DatiApp[D].Quota;
            }
        }

        state.Dati = DatiApp;
        state.QuotaRimanente = QR;
        return state;
    }

    private OnRimuovi(indice: number) {
        this.state.Dati.splice(indice, 1);
        this.CalcolaQuotaRimanente(true, false);
        this.props.OnChange(this.props.Name, JSON.stringify(this.state.Dati));
    }

    private OnAggiungi() {
        let dato: Dati.CDatoMandante = new Dati.CDatoMandante();
        if (this.state.Dati.length > 0) {
            if (this.props.ColonnaCapogruppo) {
                dato.Quota = 0;
            }
            else {
                dato.Quota = Math.trunc(this.state.Dati[this.state.Dati.length - 1].Quota * 100) / 100;
            }
        }
        else {
            dato.Quota = 50;
        }
        this.state.Dati.push(dato);
        this.props.OnChange(this.props.Name, JSON.stringify(this.state.Dati));
    }

    private CalcolaQuotaRimanente(aggiornaStato: boolean, aggiornaQuote: boolean): number {
        let QR: number = 100;
        for (let D: number = 0; D < this.state.Dati.length; D++) {
            QR -= this.state.Dati[D].Quota;
        }

        if (aggiornaQuote) {
            if (!this.props.ColonnaCapogruppo) {
                let TrovatoSuperiore: boolean = false;
                for (let D: number = 0; D < this.state.Dati.length; D++) {
                    if (this.state.Dati[D].Quota > QR) {
                        TrovatoSuperiore = true;
                        break;
                    }
                }
                if (TrovatoSuperiore) {
                    QR = 100;
                    for (let D: number = 0; D < this.state.Dati.length; D++) {
                        this.state.Dati[D].Quota = Math.trunc((100 / (this.state.Dati.length + 1)) * 100) / 100;
                        QR -= this.state.Dati[D].Quota;
                    }
                }
            }
            this.setState({ Dati: this.state.Dati });
        }

        if (aggiornaStato) {
            this.setState({ QuotaRimanente: Math.round(QR * 100) / 100 });
        }

        return QR;
    }

    private EsisteCapogruppo(): boolean {
        let esiste: boolean = false
        for (let i: number = 0; i < this.state.Dati.length; i++) {
            if (this.state.Dati[i].Capogruppo) {
                esiste = true;
                break;
            }
        }
        return esiste;
    }

    private ControllaPartitaIVA(indice: number) {
        if (!Glob.ControllaPIVA(this.state.Dati[indice].PartitaIVA)) {
            Glob.InfoModale(Trad.Trad("WARNING"), Trad.Trad("La Partita iva non è valida"));
        }
    }

    private OnAggiorna(c: string, i: number, v: any): any {
        switch (c) {
            case "ID_Anag":
                this.state.Dati[i].ID_Anag = Number(v);
                break;
            case "RagioneSociale":
                this.state.Dati[i].RagioneSociale = String(v);
                break;
            case "PartitaIVA":
                this.state.Dati[i].PartitaIVA = String(v);
                break;
            case "Capogruppo":
                if (v) {
                    if (this.EsisteCapogruppo())
                        Glob.InfoModale(Trad.Trad("WARNING"), Trad.Trad("Esiste già un capogruppo, impossibile impostarne un secondo"));
                    else
                        this.state.Dati[i].Capogruppo = v;
                } else {
                    this.state.Dati[i].Capogruppo = v;
                }
                break;
            case "Quota":
                let oldQuota: number = this.state.Dati[i].Quota;
                this.state.Dati[i].Quota = Number(v);
                if (this.props.ColonnaCapogruppo) {
                    if (this.CalcolaQuotaRimanente(false, false) <= -0.001) {
                        Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.TradParam("Impossibile impostare la quota di {1-P} perché supererebbe la soglia del 100% totale", [v]));
                        this.state.Dati[i].Quota = oldQuota;
                    }
                }
                else {
                    if (this.CalcolaQuotaRimanente(false, false) < 1) {
                        Glob.InfoModaleWarning(Trad.Trad("WARNING"), Trad.TradParam("Impossibile impostare la quota di {1-P} perché supererebbe la soglia del 100% totale", [v]));
                        this.state.Dati[i].Quota = oldQuota;
                    }
                }
                this.CalcolaQuotaRimanente(true, false);
                break;
        }
        this.props.OnChange(this.props.Name, JSON.stringify(this.state.Dati));
    }

    public render() {
        let valori: any[] = [];
        for (let i: number = 0; i < this.state.Dati.length; i++) {
            valori.push(<div className="form-group special-group kt-form login-form__group row" key={i + 1}>
                <div className="col-lg-5">
                    <div className="kt-input-icon kt-input-icon--right">
                        <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagPOS" ID_Chiave={this.state.Dati[i].ID_Anag} OnAggiorna={(e, v) => { this.OnAggiorna("ID_Anag", i, v) }} />
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="kt-input-icon kt-input-icon--right">
                        <input type="text" placeholder={Trad.Trad("Ragione Sociale")} className="form-control" value={this.state.Dati[i].RagioneSociale} id={"RagioneSociale_" + i} name={"RagioneSociale_" + i} onChange={(e) => { this.OnAggiorna("RagioneSociale", i, (e as React.FormEvent<any>).currentTarget.value) }} />
                    </div>
                </div>
                <div className={this.props.ColonnaCapogruppo ? "col-lg-2" : "col-lg-2"}>
                    <div className="kt-input-icon kt-input-icon--right">
                        <input type="text" placeholder={Trad.Trad("PIVA")} className="form-control" value={this.state.Dati[i].PartitaIVA} id={"PartitaIVA_" + i} name={"PartitaIVA_" + i} onChange={(e) => { this.OnAggiorna("PartitaIVA", i, (e as React.FormEvent<any>).currentTarget.value) }} onBlur={(e) => { this.ControllaPartitaIVA(i) }} />
                    </div>
                </div>
                {this.props.ColonnaCapogruppo &&
                    <div className="col-lg-1">
                        <label className="kt-checkbox mkt-checkbox--solid kt-checkbox--brand">
                            <input type="checkbox" value="Capogruppo" className="form-control" checked={this.state.Dati[i].Capogruppo} onChange={(e) => { this.OnAggiorna("Capogruppo", i, e.currentTarget.checked) }} />
                            {Trad.Trad("Capogruppo")}
                            <span></span>
                        </label>
                    </div>
                }
                <div className="col-lg-1">
                    <div className="kt-input-icon kt-input-icon--right">
                        <CampoNumero Valore={this.state.Dati[i].Quota} Id={"Quota_" + i} Name={"Quota_" + i} OnChange={(e) => { this.OnAggiorna("Quota", i, (e as React.FormEvent<any>).currentTarget.value) }} CSS="form-control kt-input" Icona="fa fa-percentage" />
                    </div>
                </div>
                <div className="col-lg-1 remove-square-button">
                    <button type="button" className="btn btn-danger square-button-with-icon" onClick={() => this.OnRimuovi(i)}>
                        <i className="fa fa-minus"></i>
                    </button>
                </div>
            </div>);
        }

        return <div
            className={"kt-portlet bg-fill-warning kt-portlet--brand kt-portlet--head-solid-bg kt-portlet--bordered " + this.props.CSS}>
            <div className="kt-portlet__head bg-fill-warning">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-chart-pie"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Mandanti")}
                        </h3>
                    </div>
                </div>
                <div className="portlet__head-tools">
                    <ul className="kt-portlet__nav">
                        <li className="kt-portlet__nav-item">
                            <label>
                                <i className="la la-bar-chart-o"></i> {Trad.Trad(this.props.ColonnaCapogruppo ? "Quota rimanente" : "Quota mandataria")}: {Trad.TradParam("{1-P}", [this.state.QuotaRimanente])}
                            </label>
                        </li>

                        <li className="kt-portlet__nav-item">
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                this.OnAggiungi()
                            }}
                                className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black"
                                title={Trad.Trad("Nuovo mandante")}>
                                <i className="fa fa-plus"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="kt-portlet__body">
                {valori}
            </div>
        </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/Ati.tsx